import { useEffect } from 'react';

/**
 * Hook personalizado para actualizar el título de la pestaña del navegador
 * @param {string} title - El título específico de la página
 * @param {string} subtitle - Subtítulo opcional (ej: nombre de sección)
 */
const usePageTitle = (title, subtitle) => {
  useEffect(() => {
    const previousTitle = document.title;
    
    if (subtitle) {
      document.title = `${title} - ${subtitle}`;
    } else if (title) {
      document.title = `${title}`;
    } else {
      document.title = 'Ager Espais';
    }
    
    // Restaurar el título anterior al desmontar
    return () => {
      document.title = previousTitle;
    };
  }, [title, subtitle]);
};

export default usePageTitle;
